<div style="margin: 10px 10px 10px 0px;">
  <h1>SNMP</h1>
  <form [formGroup]="SettingsForm" (ngSubmit)="applyTempChanges()">
    <div class="mb-3 row">
      <label for="name" class="col-lg-2 col-form-label">Name:</label>
      <div class="col-lg-4">
        <input id="name" type="text" class="form-control" [ngClass]="{'is-invalid':!Name.valid}" [formControl]="Name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="IsDefault" [ngClass]="{'is-invalid': !IsDefault.valid}" />
        <span class="uv-checkbox-label">Default</span>
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">Name is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="readcommunity" class="col-lg-2 col-form-label">Read Community:</label>
      <div class="col-lg-4">
        <input id="readcommunity" type="text" class="form-control" [ngClass]="{'is-invalid':!ReadCommunity.valid}" [formControl]="ReadCommunity" />
      </div>
    </div>
    @if (ReadCommunity.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger error-message">Read Community is required</div>
      </div>
    }
    <div class="mb-3 row">
      <label for="writecommunity" class="col-lg-2 col-form-label">Write Community:</label>
      <div class="col-lg-4">
        <input id="writecommunity" [type]="PasswordInputType" class="form-control" [ngClass]="{'is-invalid':!WriteCommunity.valid}"
          [formControl]="WriteCommunity" (keydown)="onPasswordKeyDownHandler($event, 'WriteCommunity')" />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="showChars" class="col-lg-2 col-form-label">&nbsp;</label>
        <div class="col-lg-2">
          <input id="showChars" type="checkbox" [formControl]="ShowChars"
            (change)="ToggleShowChars()" [ngClass]="{'is-invalid':!ShowChars.valid}" />
            <span class="uv-checkbox-label">Show Chars</span>
          </div>
        </div>
        <div class="mb-3 row">
          <label for="version" class="col-lg-2 col-form-label">SNMP Version:</label>
          <div id="version" class="col-lg-6" style="padding-left: 15px;">
            <input type="radio" name="snmpVersion" value="0" [checked]="Version.value == '0'" [formControl]="Version" />
            <span class="uv-checkbox-label" style="margin-right: 20px;">SNMP V1</span>
            <input type="radio" name="snmpVersion" value="1" [checked]="Version.value == '1'" [formControl]="Version" />
            <span class="uv-checkbox-label" style="margin-right: 20px;">SNMP V2/V2c</span>
          </div>
        </div>
        <div class="mb-3 row">
          <label for="version" class="col-lg-2 col-form-label"></label>
          <div id="get-bulk" class="col-lg-6" style="padding-left: 15px;">
            <input type="checkbox" [formControl]="UseGetBulk" />
            <span class="uv-checkbox-label">Use Get-BULK</span>
            <span class="uv-checkbox-label" style="padding-left: 50px;"></span>
            <input type="checkbox" [formControl]="DisableReplySourceCheck"/>
            <span class="uv-checkbox-label" pTooltip="Disable SNMP check for matching reply source.">Disable Reply Source Check</span>
          </div>
        </div>
        @if (Version.hasError('required')) {
          <div class="mb-3 row">
            <div class="col-lg-6 alert alert-danger error-message">Version is required</div>
          </div>
        }
        <div class="mb-3 row">
          <label for="timeout" class="col-lg-2 col-form-label">Timeout (in milliseconds):</label>
          <div class="col-lg-4">
            <input id="timeout" type="number" class="form-control" [ngClass]="{'is-invalid':!Timeout.valid}" [formControl]="Timeout" />
          </div>
        </div>
        @if (Timeout.hasError('required') || Timeout.hasError('minValue') || Timeout.hasError('maxValue')) {
          <div class="mb-3 row">
            @if (Timeout.hasError('required')) {
              <div class="col-lg-4 alert alert-danger error-message">Timeout is required</div>
            }
            @if (Timeout.hasError('minValue') || Timeout.hasError('maxValue')) {
              <div class="col-lg-4 alert alert-danger error-message">Timeout must be in the range 200 - 60000</div>
            }
          </div>
        }
        <div class="mb-3 row">
          <label for="retries" class="col-lg-2 col-form-label">Retries:</label>
          <div class="col-lg-2">
            <input id="retries" type="number" class="form-control" [ngClass]="{'is-invalid':!Retries.valid}" [formControl]="Retries" />
          </div>
        </div>
        @if (Retries.hasError('required') || Retries.hasError('minValue') || Retries.hasError('maxValue')) {
          <div class="mb-3 row">
            @if (Retries.hasError('required')) {
              <div class="col-lg-4 alert alert-danger error-message">Retries is required</div>
            }
            @if (Retries.hasError('minValue') || Retries.hasError('maxValue')) {
              <div class="col-lg-4 alert alert-danger error-message">Retries must be in the range 0 - 10</div>
            }
          </div>
        }
        <div class="mb-3 row">
          <label for="port" class="col-lg-2 col-form-label">Port:</label>
          <div class="col-lg-2">
            <input id="port" type="number" class="form-control" [ngClass]="{'is-invalid':!Port.valid}" [formControl]="Port" />
          </div>
        </div>
        @if (Port.hasError('required') || Port.hasError('minValue') || Port.hasError('maxValue')) {
          <div class="mb-3 row">
            @if (Port.hasError('required')) {
              <div class="col-lg-4 alert alert-danger error-message">Port is required</div>
            }
            @if (Port.hasError('minValue') || Port.hasError('maxValue')) {
              <div class="col-lg-4 alert alert-danger error-message">Port must be in the range 1 - 65535</div>
            }
          </div>
        }
        <div class="mb-3 row">
          <label for="blockipscope" class="col-lg-2 col-form-label">Block IP Scope:</label>
          <div class="col-lg-4">
            <textarea id="blockipscope" rows="5" cols="50" class="form-control" [formControl]="BlockIpScope"
            [ngClass]="{'is-invalid': !BlockIpScope.valid}"></textarea>
          </div>
        </div>
        <button type="submit" pButton [disabled]="!SettingsForm.valid || SettingsForm.pristine" label="Apply"></button>
      </form>
    </div>
